import React, { useState} from 'react'
import './questions.css'
import INCSUBQuestionCard from './questionCard'

function INCSUBQuestions() {

    const lineBr = ( <br />)

    const arr = [
        {
            question: 'Question 1 Is sharing subscriptions on TheSubscription legal?',
            solution: `Yes, it’s completely legal! TheSubscription ensures compliance with streaming platform's 
                       terms of service. By sharing costs responsibly, hosts and members can enjoy premium 
                       subscriptions without violating any rules.`
        },
        {
            question: 'Question 2  How much can I save by sharing a subscription?',
            solution: `You can save up to 50% or more on premium subscriptions! 
                       The more people in the pool, the more you save!`
        },
        {
            question: 'Question 3 What happens if I don’t receive my subscription access after paying?',
            solution: `If you don’t receive your credentials within 24 hours, you can raise a complaint. 
                       Our team will investigate, and if the issue isn’t resolved, you’ll get an instant 
                       refund to your wallet. Your money is always safe with us!`
        },
        {
            question: 'Question 4 How does TheSubscription ensure security and trust?',
            solution: `Verified Pools: Every host and pool is reviewed by our team before going live.
                       Secure Payments: All transactions are processed through our encrypted in-app wallet. 24/7 
                       Support: Chat with hosts or admins for quick resolution of any issues.`
        },
        {
            question: 'Question 5 Why choose TheSubscription?',
            solution: `Affordable: Save up to 50% or more by splitting with friends and family.
                       Flexible: Choose from Standard, Instant, or Rental pools to suit your needs.`
        }
    ]

    /**
 * @constant expandedIndex
 * @author Vishal Lohbande
 * @description State to track the currently expanded accordion or item index.
 * When `null`, it indicates that no item is currently expanded.
 * 
 * This is typically used in accordion UIs or toggle-based content sections
 * where only one item should be expanded at a time.
 * 
 * @type {number|null} The index of the currently expanded item or `null` if none.
 */
    const [expandedIndex, setExpandedIndex] = useState(null);

    /**
 * @function handleToggle
 * @description Handles the expand/collapse behavior for items (e.g., accordions).
 * If the clicked item is already expanded, it collapses it by setting `expandedIndex` to `null`.
 * Otherwise, it updates `expandedIndex` to the clicked item's index.
 * 
 * This logic ensures only one item can be expanded at a time.
 * 
 * @param {number} index - The index of the item being toggled.
 * 
 * Usage:
 * Typically attached to onClick of each accordion/card header to toggle visibility of its content.
 */
    const handleToggle = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
      };

/**
 * @constant renderedCards
 * @author Vishal Lohbande
 * @description Iterates over the `arr` array to render a list of `INCSUBQuestionCard`
 * components. Each item in the array is passed as a prop (`obj`) to the card.
 * 
 * The card also receives:
 * - `key`: Unique identifier based on the array index (for React rendering)
 * - `handleToggle`: A function to toggle the expanded state of each card
 * - `isExpanded`: A boolean indicating whether the current card is expanded
 * 
 * This pattern is commonly used in accordion-style interfaces, where only one
 * question card is expanded at a time based on the `expandedIndex`.
 * 
 * @returns {JSX.Element[]} An array of `INCSUBQuestionCard` components
 * 
 * Usage:
 * Used to display a list of FAQ or Q&A cards, each with collapsible content.
 */
    const renderedCards = arr?.map(( item, index)=> {
        return <INCSUBQuestionCard
        key={index}
        handleToggle={() => handleToggle(index)}
        isExpanded={expandedIndex === index}
        obj={item} 
      />
    })

    return (
        <div className='INCSUBQuestions_ctn'>
            <div className='INCSUBQuestions_ctn_holder'>
                <div className='INCSUBQuestions_ctn_holder_head'>
                    <div className='INCSUBQuestions_ctn_holder_heading'>{'FAQ'}</div>
                    <div className='INCSUBQuestions_ctn_holder_Subheading'>{'Get all your questions answered here'}</div>
                </div>
                <div className='INCSUBQuestions_ctn_QA_card_ctn'>
                   {renderedCards}
                </div>
            </div>
        </div>
    )
}

export default INCSUBQuestions
